import calls from '@/backend/api-calls'

const state = () => ({
  bom: null,
  loading: false,
  selected: [],
  allSelected: false
})

// getters
const getters = {
  detailIds: state => {
    return state.bom.details.map(d => d.id);
  }
}

// actions
const actions = {
  getBom: ({commit}, bomId) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.bom.get(bomId).then(
        resp => {
          commit("setBom", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }
      ).catch(err => {
        reject(err);
        commit("setLoading", false);
      });
    })
  },
  addDetail: ({commit}, detail) => {
    return new Promise((resolve, reject) => {
      calls.bomDetails.post(detail).then(
        resp => {
          commit("insertBomDetail", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'BOM detail successfully added'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteDetail: ({commit}, detailId) => {
    return new Promise((resolve, reject) => {
      calls.bomDetail.delete(detailId).then(
        resp => {
          commit("removeBomDetail", detailId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'BOM detail successfully deleted'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  updateDetail: ({commit}, { detailId, data }) => {
    return new Promise((resolve, reject) => {
      calls.bomDetail.put(detailId, data).then(
        resp => {
          commit("insertUpdatedBomDetail", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'BOM detail successfully updated'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  addSlabItem: ({commit}, item) => {
    return new Promise((resolve, reject) => {
      calls.bomDetails.addSlab(item).then(
        resp => {
          resp.data.forEach(item => {
            commit("insertBomDetail", item);
          })
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteSlabItem: ({commit, state}, { bomDetailId, prodSheetItemId }) => {
    return new Promise((resolve, reject) => {
      calls.bomDetail.delete(bomDetailId).then(
        resp => {

          let toDelete = state.bom.details.filter(d => {
            return d.production_sheet_item_id == prodSheetItemId;
          }).map(d => d.id);

          toDelete.forEach(id => {
            commit("removeBomDetail", id);
          });

          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Slab item successfully deleted'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.detailIds);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setBom(state, data) {
    state.bom = data;
  },
  insertBomDetail(state, bomDetail) {
    state.bom.details.push(bomDetail);
  },
  removeBomDetail(state, detailId) {
    state.bom.details.forEach((detail, i) => {
      if (detail.id == detailId) {
        state.bom.details.splice(i, 1);
      }
    })
  },
  insertUpdatedBomDetail(state, bomDetail) {
    state.bom.details.forEach((detail, i) => {
      if (detail.id == bomDetail.id) {
        state.bom.details.splice(i, 1, bomDetail);
      }
    })
  },
  selectAll(state, detailIds) {
    state.allSelected = true;
    detailIds.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}